import { MiqRegisteredBehaviors, MiqRegisteredBehaviorType } from '@shared/behaviors';

declare global {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
  interface Array<T> {
    ofType<T = any>(behaviorType: MiqRegisteredBehaviorType): T[];
  }
}

Array.prototype.ofType = function arrayOfType(behaviorType: MiqRegisteredBehaviorType): any[] {
  const objectKeysToValidate = Object.keys(MiqRegisteredBehaviors.get(behaviorType));

  return this.filter(obj => {
    return objectKeysToValidate.every(key => key in obj);
  });
};
